/**
 * Parse compartilhado do padrão de nome `UPM-{dam}-{code}` — GUPM-127/130.
 * ------------------------------------------------------------------------
 * TypeScript PURO (sem React/Supabase/DOM). Regra única usada tanto pela
 * normalização do inventário v2 (GUPM-127) quanto pelo mapper do endpoint
 * /mapa (GUPM-130) — antes duplicada em cada arquivo.
 */

/** Prefixo esperado no nome do instrumento: `UPM-{A|B|C}-{code}`. */
const PREFIXO_RE = /^UPM-([ABC])-(.+)$/;

/**
 * Parse do padrão `UPM-{dam}-{code}`. Retorna `null` se não casar — quem
 * chama decide o que fazer (ignorar com motivo, marcar como null, etc).
 *
 * `code` é retornado com `.trim()` (comportamento unificado — a normalização
 * do inventário v2 não fazia trim antes, mas a fonte real não traz espaços
 * no sufixo, então é seguro e mais correto).
 */
export function parseNomeUpm(nome: string): { dam: 'A' | 'B' | 'C'; code: string } | null {
  const m = PREFIXO_RE.exec(nome.trim());
  if (!m) return null;
  return { dam: m[1] as 'A' | 'B' | 'C', code: m[2]!.trim() };
}

/**
 * Formata o par (barragem, código) como o nome do fornecedor **menos a área**:
 * `UPM-A-TIL-02` → `A-TIL-02`. É a direção inversa de `parseNomeUpm` — GUPM-325.
 *
 * Existe porque o código sozinho é ambíguo: `TIL-01` e `TIL-02` existem nas TRÊS
 * barragens (medido em produção; foi o que motivou o `damCode` obrigatório no card
 * de perda de sinal, GUPM-303/304). Ler "TIL-02" não diz a quem despachar.
 *
 * Sem barragem conhecida devolve o código sozinho — `-TIL-02`, com o separador
 * pendurado, afirmaria uma estrutura vazia.
 */
export function codigoQualificado(damCode: string | null | undefined, code: string): string {
  return damCode ? `${damCode}-${code}` : code;
}
